@let p = profile();
@let bioText = (p?.bio | translateData) || '';
<article class="supplier-profile-card">
  <div class="supplier-profile-card__media">
    <img
      class="supplier-profile-card__logo"
      [ngSrc]="(p?.logo ?? '') | imageSource: true : 'md' : logoPlaceholder"
      [width]="120"
      [height]="120"
      [alt]="p?.title | translateData" />
  </div>
  <div class="supplier-profile-card__body">
    <div class="supplier-profile-card__heading">
      <div class="supplier-profile-card__heading-main">
        @if (showFirstName()) {
          <p class="supplier-profile-card__first-name">
            {{ firstName() }}
          </p>
        }
        @if ((p?.title | translateData); as profileTitle) {
          @if (profileTitle && profileTitle !== '-') {
            <h3 class="supplier-profile-card__title">
              {{ profileTitle }}
            </h3>
          }
        }
      </div>
      <span class="supplier-profile-card__type">{{ typeTranslationKey() | translate }}</span>
    </div>
    @if (p?.exact_role) {
      <p class="supplier-profile-card__role">{{ p.exact_role }}</p>
    }
    @if (showBio(bioText)) {
      <p
        class="supplier-profile-card__bio"
        [class.people-profile-card-locked]="isBioLocked(bioText)">
        @if (isBioLocked(bioText)) {
          {{ bio(bioText) }}
        } @else {
          {{ bioText.length > 140 ? bioText.slice(0, 140) + '…' : bioText }}
        }
      </p>
    }
    <div class="supplier-profile-card__meta">
      @if (showRegion()) {
        <span
          class="supplier-profile-card__meta-item"
          [class.people-profile-card-locked]="isRegionLocked()">
          <span class="supplier-profile-card__meta-icon" aria-hidden="true">📍</span>
          {{ region() }}
        </span>
      }
      @if (showContact()) {
        @if (email(); as contactEmail) {
          @if (isEmailLocked()) {
            <span
              class="supplier-profile-card__meta-item"
              [class.people-profile-card-locked]="true">
              <span class="supplier-profile-card__meta-icon" aria-hidden="true">✉</span>
              {{ contactEmail }}
            </span>
          } @else {
            <a
              [href]="'mailto:' + contactEmail"
              class="supplier-profile-card__meta-item supplier-profile-card__meta-link">
              <span class="supplier-profile-card__meta-icon" aria-hidden="true">✉</span>
              {{ contactEmail }}
            </a>
          }
        }
        @if (phone(); as contactPhone) {
          <span
            class="supplier-profile-card__meta-item"
            [class.people-profile-card-locked]="isPhoneLocked()">
            {{ contactPhone }}
          </span>
        }
      }
    </div>
    @if ((p?.categories?.length ?? 0) > 0 || (p?.scope_of_products?.length ?? 0) > 0) {
      <div class="supplier-profile-card__tags">
        @for (cat of (p?.categories ?? []).slice(0, 3); track cat._id) {
          <span class="supplier-profile-card__tag">{{ cat?.title | translateData }}</span>
        }
        @for (scope of (p?.scope_of_products ?? []).slice(0, 2); track scope) {
          <span class="supplier-profile-card__tag supplier-profile-card__tag--scope">{{ scope }}</span>
        }
      </div>
    }
    <div class="supplier-profile-card__badges">
      @if (p?.bim_ready) {
        <span class="supplier-profile-card__badge" title="BIM ready">BIM</span>
      }
      @if (p?.warranty_provided) {
        <span class="supplier-profile-card__badge">{{ 'industries.warranty' | translate }}</span>
      }
      @if (p?.product_certificates_provided) {
        <span class="supplier-profile-card__badge">{{ 'industries.certificates' | translate }}</span>
      }
    </div>
  </div>
</article>
